import { createSlice } from "@reduxjs/toolkit";
import { getGeneratedDatasetURLS } from "../actions/stripePayment.actions";

const initialState = {
  isLoading: false,
  data: null,
};

const getGeneratedDataSetSlice = createSlice({
  name: "Get Dataset URLs",
  initialState,
  reducers: {
    resetDatasetUrls(state) {
      (state.isLoading = initialState?.isLoading), (state.data = initialState?.data);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getGeneratedDatasetURLS.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getGeneratedDatasetURLS.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(getGeneratedDatasetURLS.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export const { resetDatasetUrls } = getGeneratedDataSetSlice.actions;
export default getGeneratedDataSetSlice.reducer;
